var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5624 24.8162C49.5624 11.1107 38.4674 0 24.7812 0C11.095 0 0 11.1107 0 24.8162C0 37.2025 9.06218 47.4693 20.9091 49.3309V31.9896H14.617V24.8162H20.9091V19.3489C20.9091 13.1293 24.6089 9.69382 30.2695 9.69382C32.9807 9.69382 35.8166 10.1785 35.8166 10.1785V16.2856H32.6918C29.6134 16.2856 28.6533 18.1986 28.6533 20.1612V24.8162H35.5262L34.4275 31.9896H28.6533V49.3309C40.5002 47.4693 49.5624 37.2027 49.5624 24.8162Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4274 31.9896L35.5261 24.8162H28.6532V20.1612C28.6532 18.1984 29.6133 16.2856 32.6917 16.2856H35.8165V10.1785C35.8165 10.1785 32.9806 9.69385 30.2692 9.69385C24.6088 9.69385 20.909 13.1293 20.909 19.3489V24.8162H14.6169V31.9896H20.909V49.3309C22.19 49.5319 23.4846 49.6327 24.7811 49.6324C26.0777 49.6328 27.3723 49.532 28.6532 49.3309V31.9896H34.4274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.97ae0c4083e51e3c53b112de7f68a639.svg";
export { ForwardRef as ReactComponent };